export default "__VITE_ASSET__Bi99riUm__"